import { render, staticRenderFns } from "./groupLessonItem.vue?vue&type=template&id=d7163d86&"
import script from "./groupLessonItem.vue?vue&type=script&lang=js&"
export * from "./groupLessonItem.vue?vue&type=script&lang=js&"
import style0 from "./groupLessonItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports